import { DataCard } from 'components/DataCardComponent/styles'
import ReactEcharts from 'echarts-for-react'
import { NotificationGetCountFieldIndex } from 'types/notification'
import { DAMAGE_LEVELS, getDamage, getDamageColor } from 'utils/damage'
import { getBirdTotal } from './getOptions'
import EmptyDataCard from 'components/DataCardComponent/EmptyDataCard'
import { useMemo } from 'react'


export const formatDataBirdGraph = (data?: NotificationGetCountFieldIndex[]) => {
    const dataChanged = DAMAGE_LEVELS?.map((d) => {
        const damage = data?.filter((dat) => dat?.index === d?.id)[0]
        let sum = data
            ?.map((d) => Number(d?.value))
            .reduce((acumulador, valorAtual) => acumulador + valorAtual, 0)
        sum = Math.max(sum, 1)
        return {
            ...d,
            countPercentage: Number(
                (100 * Number(damage?.value)) / sum
            ).toFixed(0),
            count: Number(damage?.value)
        }
    })
    return dataChanged
}
export default function BirdGraph({
    text,
    containerStyle,
    data
}: {
    text: string
    containerStyle?: string
    data?: NotificationGetCountFieldIndex[]
    }) {
    const dataChanged = useMemo(() => {
        return formatDataBirdGraph(data)
    },[data])

    return (
        <>
            {dataChanged.reduce(
                (acumulador, valorAtual) => acumulador + valorAtual.count,
                0
            ) > 0 ? (
                <DataCard
                    data-testid="test-empty-card"
                    className={containerStyle}
                >
                    <div className="flex flex-col w-full h-full">
                        <span className="text-darkGray text-base font-semibold pt-1">
                            {text}
                        </span>
                        <div className="flex flex-row">
                            <ReactEcharts
                                option={getBirdTotal(dataChanged)}
                                style={{ height: 400, width: 500 }}
                            />
                            <div className="flex flex-col self-center">
                                {dataChanged?.map((v) => (
                                    <div
                                        className="flex flex-row mt-2"
                                        key={v?.id}
                                    >
                                        <span className="w-[50px] text-right mr-2 font-semibold text-base">
                                            {Number(v?.countPercentage)} %
                                        </span>
                                        <span
                                            className={`mt-1 text-sm chip-incidente incidente-${getDamageColor(
                                                getDamage(v?.id).value
                                            )}`}
                                        >
                                            {`${getDamage(v?.id).label}`}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </DataCard>
            ) : (
                <EmptyDataCard
                    text={text}
                    containerStyle={
                        'col-span-5 bg-[#EBEBEB] h-[120px] border  border-solid border-[#E2E5EC] p-4'
                    }
                />
            )}
        </>
    )
}
